import React, { useState } from 'react'
import './project-list-item.scss'
import { DocumentUploadHistory } from './documents'
import ProjectLoanDetails from './project-loan-details'

export const ProjectButtonTabs = ({
  project,
  onChange,
}) => {
  const [docNav, setDocNav] = useState('loanDetails')

  const toggleNav = (s: string) => {
    setDocNav(docNav === s ? '' : s)
  }

  const buttons = [
    { key: 'loanDetails', label: 'Loan Details' },
    { key: 'history', label: 'History' }
  ]

  const getButtonClass = (index: number) => {
    const isActive = docNav === buttons[index].key
    const activeClass = isActive ? 'bg-primary-subtle border-primary-subtle' : ''

    const isOnlyButton = buttons.length === 1
    const isFirstButton = index === 0
    const isLastButton = index === buttons.length - 1

    let roundedClass = ''
    if (isOnlyButton) roundedClass = 'rounded-2'
    else if (isFirstButton) roundedClass = 'rounded-start-2'
    else if (isLastButton) roundedClass = 'rounded-end-2'

    return `btn ${roundedClass} ${activeClass}`
  }

  return (
    <>
      <div>
        <div className="btn-group btn-group-sm my-3">
          {buttons.map((button, index) => (
            <button
              key={button.key}
              type="button"
              className={getButtonClass(index)}
              onClick={() => toggleNav(button.key)}>
              {button.label}
            </button>
          ))}
        </div>
      </div>      
      {docNav === 'loanDetails' ? <ProjectLoanDetails project={project} onChange={onChange} /> : null}
      {docNav === 'history' ? <DocumentUploadHistory project={project} /> : null}
    </>
  )
}

export default ProjectButtonTabs